import { Activity, Boxes, type LucideIcon, SlidersHorizontal } from "lucide-react";

export type NavItem = { href: string; label: string; Icon: LucideIcon };

/**
 * Three items, split by frequency rather than by feature. Watchlist is not a
 * destination: watching is a filter on Items plus an action on a product, and
 * its rules live under Manage.
 */
export const NAV: NavItem[] = [
	{ href: "/", label: "Now", Icon: Activity },
	{ href: "/items", label: "Items", Icon: Boxes },
	{ href: "/manage", label: "Manage", Icon: SlidersHorizontal },
];

export function isNavActive(current: string, href: string): boolean {
	if (href === "/") return current === "/" || current === "";
	return current.startsWith(href);
}
